





























































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { splitThousands, emptyToLine } from "@/utils/common";

import StepList from "@/components/scope/step-list.vue";
import GeneralVehicleSelect from "@/components/scope/general-vehicle-select.vue";
import dayjs from "dayjs";
import { plateCodeRuleEl } from "@/utils/verify";

const service = namespace("service");
const user = namespace("user");
const staff = namespace("staff");
const customer = namespace("customer");
const app = namespace("app");

@Component({
  components: {
    StepList,
    GeneralVehicleSelect
  }
})
export default class ServiceView extends Vue {
  @service.Action getOrderDetail;
  @staff.Action getStaffList;
  @staff.Action getTechnicianStaffList;
  @service.Action setSupplementData;
  @service.Action orderArrival;
  @customer.Action getCustomerDetail;
  @service.Action updateOrder;
  @user.State userData;
  @customer.Action saveCustomer;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  splitThousands = splitThousands;
  dayjs = dayjs;
  showPreviewPrint: boolean = false;
  get breadData() {
    return [
      { name: window._I18N.t("test.service-management"), path: "/service/index" },
      { name: window._I18N.t("service.additional-information") }
    ];
  }
  get totalList() {
    return [
      {
        orderAmount: this.detailData.orderAmount,
        discount: this.detailData.discount,
        totalAmount: this.detailData.totalAmount,
        transactionFee: this.detailData.transactionFee,
        coupon: this.detailData.coupon
      }
    ];
  }
  logData: any = [];
  advisorList: any = [];
  technicianStaffList: any = [];
  created() {
    this.init();
    // console.log(this.$localMark);
    // console.log(this.totalList,">>>>")
  }

  get orderId() {
    return this.$route.params.id;
  }
  vehicleBrand: any = "";
  vehicleModel: any = "";
  vehiclePicture: any = "";
  vehicleModelFullName: any = "";
  emptyToLine = emptyToLine;
  detailData: any = { orderStatus: "9", photoList: [] };
  orderFormData: any = {
    advisorCode: "",
    leaveTime: dayjs().format("YYYYMMDD"),
    plateCode: "",
    customerModelCode: "",
    customerOilVolume: 0,
    customerCurrentMileage: "",
    customerNextMileage: "",
    customerNextMaintenanceDate: "",
    customerName: ""
  };
  extprops: string = ""; //后台传的车型json
  defaultVehicleList: any[] = [];
  async setSuppleMent() {
    // 更具是否选择现有用户来决定是新增用户还是更新用户
    // 老用户（订单带有用户code）直接用detailData.customerCode来更新，选择其他用户，就用this.customerCodeByPlateCode来更新用户信息
    let saveCustomerData: any = null;
    let createResult: any = null;
    if (!this.customerCodeByPlateCode) {
      saveCustomerData = {
        vehicle: {
          plateCode: this.orderFormData.plateCode,
          vehicleBrand: this.vehicleBrand,
          vehicleModel: this.vehicleModel,
          vehiclePicture: this.vehiclePicture
        },
        customerCode: this.detailData.customerCode || "",
        customerName: this.orderFormData.customerName,
        mobile: this.tmallMobile
      };
    } else {
      saveCustomerData = {
        vehicle: {
          plateCode: this.orderFormData.plateCode,
          vehicleBrand: this.vehicleBrand,
          vehicleModel: this.vehicleModel,
          vehiclePicture: this.vehiclePicture
        },
        customerCode: this.customerCodeByPlateCode,
        customerName: this.orderFormData.customerName,
        mobile: this.tmallMobile
      };
    }
    console.log("save用户数据", saveCustomerData);
    let createHasError = false;
    this.btnStartLoading();

    createResult = await this.saveCustomer(saveCustomerData).catch(err => {
      this.btnStopLoading();
      createHasError = true;
    });
    console.log("save用户结果", createResult);
    // 如果创建用户出错，终止后续操作
    if (createHasError) return;
    this.setTechnicianArray();
    const params = Object.assign({}, this.orderFormData, {
      orderNo: this.orderId,
      customerCode: createResult
        ? createResult.data.customerCode
        : this.customerCodeByPlateCode || this.detailData.customerCode,
      customerMobile: createResult ? this.tmallMobile : this.detailData.customerMobile,
      serviceDetail: this.detailData.serviceDetail,
      // 处理油量
      customerOilVolume: this.orderFormData.customerOilVolume / 20
    });
    console.log("到店数据", params);
    this.setSupplementData(params)
      .then(() => {
        this.$message.success(
          `${window._I18N.t("service.order")}“${this.orderId}”${window._I18N.t("service.customer-arrived")}`
        );
        this.$router.push(`/service/processed/${this.orderId}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }

  setTechnicianArray() {
    this.detailData.serviceDetail.forEach(serviceItem => {
      serviceItem.technicianArray = serviceItem.technicianCode.map(item => ({
        technicianCode: item
      }));
    });
  }
  // 控制form disable状态
  formDisableStatus = {
    customerModelCode: false,
    plateCode: false,
    customerName: false,
    customerMobile: false
  };
  customerFormRules: any = {
    plateCode: [{ required: true, validator: this.validatePlateCode, trigger: "change" }],
    customerCurrentMileage: [{ required: true, message: window._I18N.t("test.select-car-model"), trigger: "blur" }]
  };
  validatePlateCode(rule, value, callback) {
    plateCodeRuleEl(value, callback);
  }
  mode: string = "1";
  get additionalList() {
    if (!this.detailData.additionalFees) {
      return [];
    }
    return [
      {
        additionalFees: this.detailData.additionalFees,
        additionalFeesRemark: this.detailData.additionalFeesRemark
      }
    ];
  }
  customerCodeByPlateCode: string = "";
  handleSelectedPlatecode(val) {
    this.getCustomerDetail({
      plateCode: val
    }).then(data => {
      const customerData = data.data;
      if (customerData) {
        const vehicleData = data.data.vehicleList[0];
        this.customerCodeByPlateCode = customerData.customerCode;
        this.formDisableStatus.customerModelCode = !!vehicleData;
        this.orderFormData.customerName = customerData.customerName;
        this.detailData.customerMobile = customerData.mobile;
        this.defaultVehicleList = this.vehicleDataFormat([vehicleData]);
      } else {
        this.formDisableStatus.customerModelCode = false;
        (this.$refs["generalVeSelect"] as any).reset();
        this.orderFormData.customerName = "";
        this.detailData.customerMobile = this.tmallMobile;
        this.customerCodeByPlateCode = "";
      }
    });
  }
  vehicleDataFormat(data) {
    return data.map(item => ({
      lastValue: item.modelCode,
      name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
      valueGroup: [item.brandCode, item.seriesName, item.modelCode]
    }));
  }
  tmallMobile: string = "";
  groupIndex: number = 1;
  init() {
    this.orderArrival({
      orderNo: this.orderId
    });
    this.getTechnicianStaffList({
      // 获取角色为技师的员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.technicianStaffList = data.data.list;
    });
    this.getOrderDetail({
      orderNo: this.orderId
    }).then(data => {
      const serviceCodeMap = {}; // 存放映射关系
      data.data.partsDetail.forEach((parts, index) => {
        if (parts.serviceCode) {
          if (serviceCodeMap[parts.serviceCode]) {
            serviceCodeMap[parts.serviceCode].push(index);
          } else {
            serviceCodeMap[parts.serviceCode] = [index];
          }
        }
      });
      data.data.serviceDetail.forEach(serviceItem => {
        serviceItem.technicianCode = serviceItem.technicianArray
          ? serviceItem.technicianArray.map(item => item.technicianCode)
          : [];
        if (serviceCodeMap[serviceItem.serviceCode]) {
          serviceItem.isGroup = true;
          serviceItem.groupServiceIndex = this.groupIndex;
          serviceCodeMap[serviceItem.serviceCode].forEach(i => {
            data.data.partsDetail[i].isGroup = true;
            data.data.partsDetail[i].groupServiceIndex = this.groupIndex;
          });
          this.groupIndex++;
          // 格式化技师code
        }
      });
      this.detailData = data.data;
      console.log(this.detailData, "qqqqqq");

      // 设置车型默认
      this.defaultVehicleList = [
        {
          lastValue: data.data.customerModelCode,
          name: data.data.modelDesc
        }
      ];
      // 到店订单，根据值设置disable
      if (data.data.orderSource === "1") {
        this.formDisableStatus.plateCode = true;
        this.formDisableStatus.customerModelCode = true;
        this.formDisableStatus.customerName = !!data.data.customerName;
        this.formDisableStatus.customerMobile = !!data.data.customerMobile;
      }
      //saveconstumer参数
      if (data.data.extProps !== null) {
        this.vehicleBrand = JSON.parse(data.data.extProps).vehicleBrand;
        this.vehicleModel = JSON.parse(data.data.extProps).vehicleModel;
        this.vehiclePicture = JSON.parse(data.data.extProps).vehiclePicture;
        this.vehicleModelFullName = JSON.parse(data.data.extProps).vehicleModelFullName;
      }

      // 设置客户姓名
      this.orderFormData.customerName = data.data.customerName;
      // 设置车型code
      this.orderFormData.customerModelCode = data.data.customerModelCode;
      // 设置车牌号
      this.orderFormData.plateCode = data.data.plateCode;
      // 如果是天猫订单，保存订单里面的手机号
      this.tmallMobile = this.detailData.customerMobile;
      // 设置下次保养时间和里程
      this.orderFormData.customerNextMileage = this.detailData.customerNextMileage || "";
      this.orderFormData.customerNextMaintenanceDate = this.detailData.customerNextMaintenanceDate || "";
    });
    // 获取员工设置 顾问
    this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      this.orderFormData.advisorCode = this.userData.userCode;
    });
  }
  handleOpoColse() {
    // 车型选择关闭去掉错误状态
    (this.$refs["customerForm"] as any).validateField("customerModelCode");
  }
  submitForm() {
    (this.$refs["customerForm"] as any).validate(valid => {
      if (valid && this.checkDatavalid()) {
        if (this.detailData.orderSource === "2") {
          // 天猫
          this.setSuppleMent();
        } else {
          this.updateOrderInfo();
        }
      } else {
        console.log("error submit!! ");
      }
    });
  }
  roderMapping: any = {
    "1": "maintenance",
    "2": "wash",
    "3": "retail"
  };
  get orderType() {
    return this.roderMapping[this.detailData.orderType] || "maintenance";
  }
  checkDatavalid(): boolean {
    for (let index = 0; index < this.detailData.serviceDetail.length; index++) {
      // 洗车项目 技师可以为空
      const element = this.detailData.serviceDetail[index];
      if (this.orderType !== "wash" && (!element.technicianCode || element.technicianCode.length < 1)) {
        this.$message.error(window._I18N.t("service.select-service-technician"));
        return false;
      }
    }
    return true;
  }

  updateOrderInfo() {
    this.btnStartLoading();
    this.setTechnicianArray();
    let params = Object.assign(this.detailData, {
      customerOilVolume: this.orderFormData.customerOilVolume / 20,
      customerCurrentMileage: this.orderFormData.customerCurrentMileage,
      customerNextMaintenanceDate: this.orderFormData.customerNextMaintenanceDate,
      customerNextMileage: this.orderFormData.customerNextMileage,
      customerName: this.orderFormData.customerName,
      arrivalStore: true,
      orderNo: this.orderId
    });
    const saveCustomerData = {
      vehicle: {
        plateCode: this.orderFormData.plateCode,
        vehicleBrand: this.vehicleBrand,
        vehicleModel: this.vehicleModel,
        vehiclePicture: this.vehiclePicture
      },
      customerCode: this.detailData.customerCode,
      customerName: this.orderFormData.customerName,
      mobile: this.detailData.customerMobile
    };
    this.saveCustomer(saveCustomerData).catch(err => {
      this.btnStopLoading();
    });

    this.updateOrder(params)
      .then(data => {
        this.$message.success(window._I18N.t("service.arrived-store"));
        this.$router.push(`/service/processed/${this.orderId}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
}
